import { render, staticRenderFns } from "./FollowUpDetails.vue?vue&type=template&id=10c78dd4&scoped=true"
import script from "./FollowUpDetails.vue?vue&type=script&lang=js"
export * from "./FollowUpDetails.vue?vue&type=script&lang=js"
import style0 from "./FollowUpDetails.vue?vue&type=style&index=0&id=10c78dd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c78dd4",
  null
  
)

export default component.exports